import { Stack } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { StatusSection } from "./StatusSection"
import { TitleSection } from "./TitleSection"
import { NewsTicker } from "./NewsTicker"

const useStyles = makeStyles()((theme) => ({
    wrap: {
        position: "fixed",
        bottom: 0,
        left: 0,
        background: theme.palette.common.white,
        zIndex: 1,
    },
}))

export function ConferenceInfo() {
    const { classes } = useStyles()

    return (
        <Stack flexDirection="row" className={classes.wrap}>
            <TitleSection />
            <Stack justifyContent="space-between">
                <StatusSection />
                <NewsTicker />
            </Stack>
        </Stack>
    )
}
